import React from 'react';
import { modelClass } from '/imports/api/tradeItems';
import { ModelListPage } from '/imports/ui/ModelListPage';
import { useUser } from '/imports/hooks';

export const TradeItemsPage = () => (
  <ModelListPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    columns={[{ field: 'bot', label: 'Bot' }, { field: 'partner', label: 'Partner' }, { field: 'card', label: 'Card' }, { field: 'qty', label: 'Qty', className: 'mono' }, { field: 'action', label: 'Action' }, { field: 'price', label: 'Price', className: 'mono' }]}
  />
);

// keep unused import live so tree-shaking doesn't drop the hook
void useUser;
